import { render } from "./EventviewSidebarMatch.vue?vue&type=template&id=214acb5e"
import script from "./EventviewSidebarMatch.vue?vue&type=script&lang=js"
export * from "./EventviewSidebarMatch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__